import * as React from 'react';
import { PageWrapper } from 'components/widgets/PageWrapper';
import { observer } from 'mobx-react';
import { TrackersData } from 'data/TrackersData';

import { MyWellnessTabBar } from 'components/mywellness/MyWellnessTabBar';
import { TrackersSubPage } from 'components/mywellness/TrackersSubPage';

import { TitleBar } from 'components/widgets/TitleBar';
import { TrackerDetailSubPage } from 'components/mywellness/TrackerDetailSubPage';
import { GoalsSubPage } from 'components/mywellness/GoalsSubPage';
import { ProfileSubPage } from 'components/account/ProfileSubPage';
import { JournalSubPage } from 'components/mywellness/JournalSubPage';
import { ManageTrackersSubPage } from './ManageTrackersSubPage';


import './MyWellnessPage.pcss';
import { UIState } from 'data/UIState';
import {PageEnum, PageEnums} from "components/nav/PageEnums";
import {PrimaryLayout} from "../widgets/PrimaryLayout";

/**
 * Top Level My Wellness page
 * 
 */
@observer
class MyWellnessPage extends React.Component<{nav:any}> {

  constructor(props:{nav:any}){
    super(props);
    TrackersData.load();
  }

  render() {
    const pageEnum = new PageEnum(`${PageEnums.myWellness.name} no-right${UIState.iOS?'':' not-ios'}`); //PageEnums.myWellness.title);
    return (
			<div>
				{this.props.nav}
        <PageWrapper pageEnum={pageEnum} noPadding >
          <TopLevelSubPages /> 
          <TrackerDetailSubPageWrapper /> 
          <ManageTrackersSubPageWrapper /> 
        </PageWrapper>              
      </div>
    );

  }
}



/**
 * Manage Trackers
 * 
 * @param props 
 */
const ManageTrackersSubPageWrapper = observer(() => (!TrackersData.showManageTrackersSubPage ? null : 
<SecondLevelSubPageWrapper title='Manage Trackers' onBack={()=>{ TrackersData.showManageTrackersSubPage = false; }}>
  <ManageTrackersSubPage />
</SecondLevelSubPageWrapper>
));


/**
 * Tracker Detail page
 * 
 * @param props 
 */
const TrackerDetailSubPageWrapper = observer(() => (!TrackersData.showTrackerDetailSubPage ? null : 
<SecondLevelSubPageWrapper title={TrackersData.selectedTracker?TrackersData.selectedTracker.name:''} onBack={TrackersData.deselectTracker}>
  <TrackerDetailSubPage />
</SecondLevelSubPageWrapper>
));

/**
 * Displayed when at the top My Wellness Tab level
 * 
 * @param props 
 */
const TopLevelSubPages = observer(() => (!TrackersData.showTopLevelSubPages ? null : 
<React.Fragment>
  <MyWellnessTabBar />          
  <div className="subpage">
    <JournalSubPage />
    <TrackersSubPage />
    <GoalsSubPage />
    <ProfileSubPage />
  </div>
</React.Fragment>
));


/**
 * Wrap simple pages with title and back arrow
 * 
 * @param props 
 */
const SecondLevelSubPageWrapper = (props:{children:any, title:string, onBack:()=>void}) => 
<React.Fragment>
  <TitleBar title={props.title} onBack={props.onBack} />          
  <div className="subpage">
    {props.children}
  </div>
</React.Fragment>
;




export { MyWellnessPage };
